import React from 'react';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import streamingReadinessIcon from '../../assets/streamingReadiness.svg';
import './StreamingReadinessBanner.scss';

export default function StreamingReadinessBanner({ onRunTest, isSubscribed, isLoading }) {
    const { ref, focused } = useFocusable({
        focusKey: 'readiness-banner-row',
        onEnterPress: onRunTest,
        onFocus: () => {
            ref.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        },
    });

    return (
        <div ref={ref} className="SrBanner">
            <div className="SrBanner__copy">
                <h2 className="SrBanner__title">Streaming Readiness</h2>
                <p className="SrBanner__subtitle">Run a test to make sure your device is ready before an event.</p>
            </div>
            <button
                type="button"
                className={`SrBanner__btn${focused ? ' SrBanner__btn--focused' : ''}`}
                onClick={onRunTest}
                disabled={isLoading}
                tabIndex={0}
            >
                <img src={streamingReadinessIcon} className="SrBanner__icon" alt="" aria-hidden="true" />
                <span>{isSubscribed ? 'Stop Streaming Readiness' : 'Run Test'}</span>
            </button>
        </div>
    );
}
